<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
    </svg>
</template>

<script>
export default {
    name: 'PlusIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
